import { useEffect } from 'react';

type Props = {
  visible: boolean;
  variant: 'hearts' | 'confetti';
  onFinish?: () => void;
};

/**
 * Webpack: `lottie-react-native` web girişi @lottiefiles/dotlottie-react ister; burada hiç import etmiyoruz.
 * Görsel yok; üst bileşenin state’ini `onFinish` ile aynı sürede temizler.
 */
export function LottieOverlayBurst({ visible, variant, onFinish }: Props) {
  useEffect(() => {
    if (!visible) {
      return;
    }
    const ms = variant === 'confetti' ? 1600 : 1200;
    const t = setTimeout(() => {
      onFinish?.();
    }, ms);
    return () => clearTimeout(t);
  }, [visible, variant, onFinish]);

  return null;
}
